import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux/es/exports";
import { useNavigate } from "react-router-dom";
import { fetchCroppedImage, fetchThemeEdit, getHomeJsonList } from "../../redux/Actions";
import ImageCropper from "../imageCropper/imageCropper";
import FooterOne from "../footer/footerOne";
import FooterEdit from "./footer-edit/footer3-edit";
import HeaderOne from "../header/headerOne";
import HeaderThree from "../header/headerThree";
import HeaderThreeEdit from "./header-edit/header3-edit";
import HeaderOneEdit from "./header-edit/header1-edit";
import SectionOneEditThemeThree from "./section1Edit/SectionOneEditThemeThree";
import SectionOneEditThemeThreeBlack from "./section1Edit/SectionOneEditThemeThree";
import SectionThreeThemeThreeEdit from "./SectionThreeEdit/SectionThreeThemeThreeEdit";
import SectionThreeThemeOneEdit from "./SectionThreeEdit/SectionThreeThemeOneEdit";
import SectionFourBannerThemeThree from "./sectionFourBanner/SectionFourBannerThemeThree";
import SectionFourBannerThemeThreeBlack from "./sectionFourBanner/SectionFourBannerThemeThreeBlack";
import SectionFourBannerThemeOne from "./sectionFourBanner/SectionFourBannerThemeOne";
import SectionSixBannerThemeThree from "./sectionSixBanner/SectionSixBannerThemeThree";
import SectionSixBannerThemeThreeBlack from "./sectionSixBanner/SectionSixBannerThemeThreeBlack";
import SectionSixBannerThemeOne from "./sectionSixBanner/SectionSixBannerThemeOne";
import SectionSevenBannerThemeThree from "./sectionSevenBanner/SectionSevenBannerThemeThree";
import SectionSevenBannerThemeThreeBlack from "./sectionSevenBanner/SectionSevenBannerThemeThreeBlack";
import SectionSevenBannerThemeOne from "./sectionSevenBanner/SectionSevenBannerThemeOne";
import SectionNineBannerThemeOne from "./sectionNineBanner/SectionNineBannerThemeOne";
import SectionNineBannerThemeThree from "./sectionNineBanner/SectionNineBannerThemeThree";
import SectionNineBannerThemeThreeBlack from "./sectionNineBanner/SectionNineBannerThemeThreeBlack";
import SectionFiveThemeThreeEdit from "./SectionFiveEdit/SectionFiveThemeThreeEdit";
import SectionFiveThemeOneEdit from "./SectionFiveEdit/SectionFiveThemeOneEdit";
import SectionOneEditThemeOne from "./section1Edit/sectionOneEditThemeOne";
import SectionTenThemeThree from "./section10Edit/sectionTenThemeThree";
import SectionTenThemeThreeBlack from "./section10Edit/SectionTenThemeThreeBlack";
import SectionTenThemeOne from "./section10Edit/sectionTenThemeOne";
import SectionTwelveThemeThree from "./section12Edit/sectionTwelveThemeThree";
import SectionTwelveThemeThreeBlack from "./section12Edit/SectionTwelveThemeThreeBlack";
import SectionEightThemeOneEdit from "./SectionEightThemeThreeEdit/SectionEightThemeOneEdit";
import SectionEightThemeThreeEdit from "./SectionEightThemeThreeEdit/SectionEightThemeThreeEdit";
import SectionElevenThemeThreeEdit from "./SectionElevenEdit/SectionElevenThemeThreeEdit";
import SectionFifteenThemeThreeEdit from "./SectionFifteenEdit/SectionFifteenThemeThreeEdit";
import SectionThirteenThemeThreeEdit from "./clickAway/SectionThirteenThemeThreeEdit";
import SectionThemeThreeEditor from "./ThemeEditor/SectionThemeThreeEditor";
import SectionThemeThreeEditorBlack from "./ThemeEditor/SectionThemeThreeEditor";
import SectionThemeOneEditor from "./ThemeEditor/SectionThemeOneEditor";
import HeaderTwo from "../header/headerTwo";
import HeaderTwoEdit from "./header-edit/header2-edit";
import SectionTwoEditThemeTwo from "./section2Edit/sectionTwoEditThemeTwo";
import SectionOneThemeTwoEdit from "./section1Edit/sectionOneEditThemeTwo";
import SectionThreeThemeTwoEdit from "./section3/sectionThreeThemeTwo";
import SectionFiveThemeTwoEdit from "./SectionFiveEdit/SectionFiveThemeTwoEdit";
import SectionSevenBannerThemeTwo from "./sectionSevenBanner/SectionSevenBannerThemeTwo";
import SectionEightThemeTwoEdit from "./SectionEightThemeThreeEdit/SectionEightThemeTwoEdit";
import SectionNineBannerThemeTwo from "./sectionNineBanner/SectionNineBannerThemeTwo";
import SectionThemeTwoEditor from "./ThemeEditor/SectionThemeTwoEditor";
import SectionSixBannerThemeTwo from "./sectionSixBanner/SectionSixBannerThemeTwo";
import FooterTwo from "../footer/footerTwo";
import FooterThree from "../footer/footerThree";
import FooterOneEdit from "./footer-edit/footer1-edit";
import FooterThreeEdit from "./footer-edit/footer3-edit";
import FooterTwoEdit from "./footer-edit/footer2-edit";
import HeaderFour from "../header/headerFour";
import FooterFour from "../footer/footerFour";
import HeaderFourEdit from "./header-edit/header4-edit";
import SectionOneEditThemeFour from "./section1Edit/SectionOneEditThemeFour";
import SectionTwoThemeFourEdit from "./section2Edit/sectionTwoEditThemeFour";
import SectionThreeThemeFourEdit from "./SectionThreeEdit/SectionThreeThemeFourEdit";
import SectionFourThemeFourEdit from "./sectionFourBanner/SectionFourBannerThemeFour";
import SectionEightThemeFourEdit from "./SectionEightThemeThreeEdit/SectionEightThemeFourEdit";
import SectionSixBannerThemeFour from "./sectionSixBanner/SectionSixBannerThemeFour";
import SectionNineBannerThemeFour from "./sectionNineBanner/SectionNineBannerThemeFour";
import SectionTwelveBannerThemeFour from "./sectionTwelveBanner/SectionTwelveBannerThemeFour";
import SectionFiveThemeFourEdit from "./SectionFiveEdit/SectionFiveThemeFourEdit";
import SectionTenThemeFourEdit from "./section10Edit/sectionTenThemeFour";
import SectionThemeFourEditor from "./ThemeEditor/SectionThemeFourEditor";
import SectionSevenBannerThemeFour from "./sectionSevenBanner/SectionSevenBannerThemeFour";
import SectionElevenThemeFourEdit from "./SectionElevenEdit/SectionElevenThemeFourEdit";
import FooterFourEdit from "./footer-edit/footer4-edit";
import SectionOneEditThemeFive from "./section1Edit/SectionOneEditThemeFive";
// import HeaderFive from "../header/headerFive";
// import "../../assets/css/style1.css"
import HeaderFive from "../header/headerFive";
import HeaderFiveEdit from "./header-edit/header5-edit";
import FooterFive from "../footer/footerFive";
import SectionSevenBannerThemeFive from "./sectionSevenBanner/SectionSevenBannerThemeFive";
import SectionFourThemeFiveEdit from "./sectionFourBanner/SectionFourBannerThemeFive";
import SectionFiveThemeFiveEdit from "./SectionFiveEdit/SectionFiveThemeFiveEdit";
import FooterFiveEdit from "./footer-edit/footer5-edit";
import SectionEightThemeFiveEdit from "./SectionEightThemeThreeEdit/SectionEightThemeFiveEdit";
import SectionThemeFiveEditor from "./ThemeEditor/SectionThemeFiveEditor";
import SectionSixBannerThemeFive from "./sectionSixBanner/SectionSixBannerThemeFive";
import SectionSelfServiceThemeFiveEdit from "./SectionFiveEdit/SectionSelfServiceThemeFiveEdit";
import SectionOurServiceThemeFiveEdit from "./SectionFiveEdit/SectionOurServiceThemeFiveEdit";
import HeaderBlack from "../header/headerBlack";
import FooterBlack from "../footer/footerBlack";
import SectionThreeThemeThreeEditBlack from "./SectionThreeEdit/SectionThreeThemeThreeEditBlack";
import SectionFiveThemeThreeEditBlack from "./SectionFiveEdit/SectionFiveThemeThreeEditBlack";
import SectionEightThemeThreeEditBlack from "./SectionEightThemeThreeEdit/SectionEightThemeThreeEditBlack";
import SectionElevenThemeThreeEditBlack from "./SectionElevenEdit/SectionElevenThemeThreeEditBlack";
import SectionThirteenThemeThreeEditBlack from "./clickAway/SectionThirteenThemeThreeEditBlack";
import SectionFifteenThemeThreeEditBlack from "./SectionFifteenEdit/SectionFifteenThemeThreeEditBlack";
import HeaderTenEdit from "./header-edit/header10-edit";
import FooterTenEdit from "./footer-edit/footer10-edit";

function Edit() {
  const settingsData: any = useSelector<any>((state) => state?.settings);
  const jsonData: any = useSelector<any>((state) => state.homeJsonList);
  const dispatch = useDispatch<any>();
  const navigate = useNavigate();

  useEffect(() => {
    const url = new URL(window.location.href);
    const token = url.searchParams.get("token");
    const host = window.location.hostname;
    // checks the token if its not in localhost 
    if (host !== "localhost") {
      if (token != null) {
        dispatch(fetchThemeEdit(token)).then((res: any) => {
          if (res == false) {
            navigate("/");
          }
        });
      } else {
        navigate("/");
      }
    }
  }, []);
  useEffect(() => {
    dispatch(getHomeJsonList());
  }, []);
  return (
    <>
    <div className="sec-home">
      <div className="section-editor">
        <a
          href="javascript:void(0);"
          data-bs-toggle="modal"
          data-bs-target="#headerEditmodal"
          className="section-editor-icon"
        >
          <i className="fas fa-edit"></i>
        </a>
      </div>
      <div
        className={`section-editor ${
          settingsData?.template == 4 ? "section-editor4" : ""
        }`}
      >
        <a
          href="javascript:void(0);"
          data-bs-toggle="modal"
          data-bs-target="#sectiononeEditmodal"
          className="section-editor-icon"
        >
          <i className="fas fa-edit"></i>
        </a>
      </div>

      <div className="section-editor">
        <a
          href="javascript:void(0);"
          data-bs-toggle="modal"
          data-bs-target="#section2Editmodal"
          className="section-editor-icon"
        >
          <i className="fas fa-edit"></i>
        </a>
        {/* {settingsData?.template == 1 &&
          jsonData?.theme_1?.home?.sections[1]?.is_section_enable === true && (
            <>
              <SectionTwoBannerThemeOne />
            </>
          )} */}
      </div>
      <div
        className="modal fade"
        id="section2Editmodal"
        aria-hidden="true"
        data-bs-keyboard="false"
      >
        {/* {settingsData?.template == 1 && <SectionTwoEditThemeOne />} */}
        {settingsData?.template == 2 && <SectionTwoEditThemeTwo />}
        {/* {settingsData?.template == 3 && <SectionTwoEditThemeThree />} */}
        {settingsData?.template == 4 && <SectionTwoThemeFourEdit />}
      </div>
      <div className="section-editor">
        <a
          href="javascript:void(0);"
          data-bs-toggle="modal"
          data-bs-target="#section3Editmodal"
          className="section-editor-icon"
        >
          <i className="fas fa-edit"></i>
        </a>
      </div>

      <div
        className="modal fade"
        id="section3Editmodal"
        aria-hidden="true"
        data-bs-keyboard="false"
      >
        {settingsData?.template == 1 && <SectionThreeThemeOneEdit />}
        {settingsData?.template == 2 && <SectionThreeThemeTwoEdit />}
        {settingsData?.template == 3 && <SectionThreeThemeThreeEdit />}
        {settingsData?.template == 10 && <SectionThreeThemeThreeEditBlack />}
        {settingsData?.template == 4 && <SectionThreeThemeFourEdit />}
      </div>

      <div className="section-editor">
        <a
          href="javascript:void(0);"
          data-bs-toggle="modal"
          data-bs-target="#section4Editmodal"
          className="section-editor-icon"
        >
          <i className="fas fa-edit"></i>
        </a>
      </div>
      <div
        className="modal fade"
        id="section4Editmodal"
        aria-hidden="true"
        data-bs-keyboard="false"
      >
      </div>

      <div className="section-editor">
        <a
          href="javascript:void(0);"
          data-bs-toggle="modal"
          data-bs-target="#sectionSelfServiceEditmodal"
          className="section-editor-icon"
        >
          <i className="fas fa-edit"></i>
        </a>
      </div>

      <div className="section-editor">
        <a
          href="javascript:void(0);"
          data-bs-toggle="modal"
          data-bs-target="#sectionOurServiceEditmodal"
          className="section-editor-icon"
        >
          <i className="fas fa-edit"></i>
        </a>
      </div>

      <div className="section-editor">
        <a
          href="javascript:void(0);"
          data-bs-toggle="modal"
          data-bs-target="#section5Editmodal"
          className="section-editor-icon"
        >
          <i className="fas fa-edit"></i>
        </a>
      </div>

      <div
        className="modal fade"
        id="section5Editmodal"
        aria-hidden="true"
        data-bs-keyboard="false"
      >
      </div>

      <div className="section-editor">
        <a
          href="javascript:void(0);"
          data-bs-toggle="modal"
          data-bs-target="#section6Editmodal"
          className="section-editor-icon"
        >
          <i className="fas fa-edit"></i>
        </a>
      </div>

      

      <div
        className="modal fade"
        id="sectionSelfServiceEditmodal"
        aria-hidden="true"
        data-bs-keyboard="false"
      >
        {settingsData?.template == 5 && <SectionSelfServiceThemeFiveEdit />}
      </div>

      <div
        className="modal fade"
        id="sectionOurServiceEditmodal"
        aria-hidden="true"
        data-bs-keyboard="false"
      >
        {settingsData?.template == 5 && <SectionOurServiceThemeFiveEdit />}
      </div>

      <div
        className="modal fade"
        id="section6Editmodal"
        aria-hidden="true"
        data-bs-keyboard="false"
      >
        {settingsData?.template == 1 && <SectionSixBannerThemeOne />}
        {settingsData?.template == 2 && <SectionSixBannerThemeTwo />}
        {settingsData?.template == 3 && <SectionSixBannerThemeThree />}
        {settingsData?.template == 10 && <SectionSixBannerThemeThreeBlack />}
        {settingsData?.template == 4 && <SectionSixBannerThemeFour />}
        {settingsData?.template == 5 && <SectionSixBannerThemeFive />}
      </div>

      <div className="section-editor">
        <a
          href="javascript:void(0);"
          data-bs-toggle="modal"
          data-bs-target="#section7Editmodal"
          className="section-editor-icon"
        >
          <i className="fas fa-edit"></i>
        </a>
      </div>

      <div
        className="modal fade"
        id="section7Editmodal"
        aria-hidden="true"
        data-bs-keyboard="false"
      >
        {settingsData?.template == 1 && <SectionSevenBannerThemeOne />}
        {settingsData?.template == 2 && <SectionSevenBannerThemeTwo />}
        {settingsData?.template == 3 && <SectionSevenBannerThemeThree />}
        {settingsData?.template == 10 && <SectionSevenBannerThemeThreeBlack />}
        {settingsData?.template == 4 && <SectionSevenBannerThemeFour />}
        {settingsData?.template == 5 && <SectionSevenBannerThemeFive />}
      </div>

      <div className="section-editor">
        <a
          href="javascript:void(0);"
          data-bs-toggle="modal"
          data-bs-target="#section8Editmodal"
          className="section-editor-icon"
        >
          <i className="fas fa-edit"></i>
        </a>
      </div>

      <div
        className="modal fade"
        id="section8Editmodal"
        aria-hidden="true"
        data-bs-keyboard="false"
      >
        {settingsData?.template == 1 && <SectionEightThemeOneEdit />}
        {settingsData?.template == 2 && <SectionEightThemeTwoEdit />}
        {settingsData?.template == 3 && <SectionEightThemeThreeEdit />}
        {settingsData?.template == 10 && <SectionEightThemeThreeEditBlack />}
        {settingsData?.template == 4 && <SectionEightThemeFourEdit />}
        {settingsData?.template == 5 && <SectionEightThemeFiveEdit />}
      </div>

      <div className="section-editor">
        <a
          href="javascript:void(0);"
          data-bs-toggle="modal"
          data-bs-target="#section9Editmodal"
          className="section-editor-icon"
        >
          <i className="fas fa-edit"></i>
        </a>
      </div>

      <div
        className="modal fade"
        id="section9Editmodal"
        aria-hidden="true"
        data-bs-keyboard="false"
      >
        {settingsData?.template == 1 && <SectionNineBannerThemeOne />}
        {settingsData?.template == 2 && <SectionNineBannerThemeTwo />}
        {settingsData?.template == 3 && <SectionNineBannerThemeThree />}
        {settingsData?.template == 10 && <SectionNineBannerThemeThreeBlack />}
        {settingsData?.template == 4 && <SectionNineBannerThemeFour />}
      </div>

      <div className="section-editor">
        <a
          href="javascript:void(0);"
          data-bs-toggle="modal"
          data-bs-target="#section10Editmodal"
          className="section-editor-icon"
        >
          <i className="fas fa-edit"></i>
        </a>
      </div>

      <div
        className="modal fade"
        id="section10Editmodal"
        aria-hidden="true"
        data-bs-keyboard="false"
      >
        {settingsData?.template == 1 && <SectionTenThemeOne />}
        {settingsData?.template == 3 && <SectionTenThemeThree />}
        {settingsData?.template == 10 && <SectionTenThemeThreeBlack />}
        {settingsData?.template == 4 && <SectionTenThemeFourEdit />}
      </div>

      <div className="section-editor">
        <a
          href="javascript:void(0);"
          data-bs-toggle="modal"
          data-bs-target="#section11Editmodal"
          className="section-editor-icon"
        >
          <i className="fas fa-edit"></i>
        </a>
      </div>

      <div
        className="modal fade"
        id="section11Editmodal"
        aria-hidden="true"
        data-bs-keyboard="false"
      >
        {settingsData?.template == 3 && <SectionElevenThemeThreeEdit />}
        {settingsData?.template == 10 && <SectionElevenThemeThreeEditBlack />}
        {settingsData?.template == 4 && <SectionElevenThemeFourEdit />}
      </div>

      <div className="section-editor">
        <a
          href="javascript:void(0);"
          data-bs-toggle="modal"
          data-bs-target="#section12Editmodal"
          className="section-editor-icon"
        >
          <i className="fas fa-edit"></i>
        </a>
      </div>

      <div
        className="modal fade"
        id="section12Editmodal"
        aria-hidden="true"
        data-bs-keyboard="false"
      >
        {settingsData?.template == 3 && <SectionTwelveThemeThree />}
        {settingsData?.template == 10 && <SectionTwelveThemeThreeBlack />}
        {/* <SectionTwelveThemeThree /> */}
        {settingsData?.template == 4 && <SectionTwelveBannerThemeFour />}
      </div>

      <div className="section-editor">
        <a
          href="javascript:void(0);"
          data-bs-toggle="modal"
          data-bs-target="#section13Editmodal"
          className="section-editor-icon"
        >
          <i className="fas fa-edit"></i>
        </a>
      </div>

      <div
        className="modal fade"
        id="section13Editmodal"
        aria-hidden="true"
        data-bs-keyboard="false"
      >
        {settingsData?.template == 3 && <SectionThirteenThemeThreeEdit />}
        {settingsData?.template == 10 && <SectionThirteenThemeThreeEditBlack />}
      </div>
      <div className="section-editor">
        <a
          href="javascript:void(0);"
          data-bs-toggle="modal"
          data-bs-target="#section15Editmodal"
          className="section-editor-icon"
        >
          <i className="fas fa-edit"></i>
        </a>
      </div>

      <div
        className="modal fade"
        id="section15Editmodal"
        aria-hidden="true"
        data-bs-keyboard="false"
      >
        {settingsData?.template == 3 && <SectionFifteenThemeThreeEdit />}
        {settingsData?.template == 10 && <SectionFifteenThemeThreeEditBlack />}
      </div>

      <div className="section-editor">
        <a
          href="javascript:void(0);"
          data-bs-toggle="modal"
          data-bs-target="#footerEditmodal"
          className="section-editor-icon"
        >
          <i className="fas fa-edit"></i>
        </a>
        {settingsData?.template == 1 && <FooterOne />}
        {settingsData?.template == 2 && <FooterTwo />}
        {settingsData?.template == 3 && <FooterThree />}
        {settingsData?.template == 10 && <FooterBlack />}
        {settingsData?.template == 4 && <FooterFour />}
        {settingsData?.template == 5 && <FooterFive />}
      </div>

      <div
        className="modal fade"
        id="sectiononeEditmodal"
        aria-hidden="true"
        data-bs-keyboard="false"
      >
        {settingsData?.template == 1 && <SectionOneEditThemeOne />}
        {settingsData?.template == 2 && <SectionOneThemeTwoEdit />}
        {settingsData?.template == 3 && <SectionOneEditThemeThree />}
        {settingsData?.template == 10 && <SectionOneEditThemeThreeBlack />}
        {settingsData?.template == 4 && <SectionOneEditThemeFour />}
        {settingsData?.template == 5 && <SectionOneEditThemeFive />}
      </div>
      <div
        className="modal fade"
        id="headerEditmodal"
        aria-hidden="true"
        data-bs-keyboard="false"
      >
        {settingsData?.template == 1 && <HeaderOneEdit />}
        {settingsData?.template == 2 && <HeaderTwoEdit />}
        {settingsData?.template == 3 && <HeaderThreeEdit />}
        {settingsData?.template == 10 && <HeaderTenEdit />}
        {settingsData?.template == 4 && <HeaderFourEdit />}
        {settingsData?.template == 5 && <HeaderFiveEdit />}
      </div>

      <div
        className="modal fade"
        id="footerEditmodal"
        aria-hidden="true"
        data-bs-keyboard="false"
      >
        {/* <FooterEdit /> */}
        {settingsData?.template == 1 && <FooterOneEdit />}
        {settingsData?.template == 2 && <FooterTwoEdit />}
        {settingsData?.template == 3 && <FooterThreeEdit />}
        {settingsData?.template == 10 && <FooterTenEdit />}
        {settingsData?.template == 4 && <FooterFourEdit />}
        {settingsData?.template == 5 && <FooterFiveEdit />}
      </div>
      <div className="theme-changer-home">
        <a href="/">
          <i className="fas fa-sign-out-alt"></i>
        </a>
      </div>
      <div className="theme-changer">
        <a
          href="javascript:void(0);"
          data-bs-toggle="modal"
          data-bs-target="#themeColorEditmodal"
        >
          <i className="fas fa-cog"></i>
        </a>
      </div>
      <div
        className="modal fade"
        id="themeColorEditmodal"
        aria-hidden="true"
        data-bs-keyboard="false"
      >
        {settingsData?.template == 1 && <SectionThemeOneEditor />}
        {settingsData?.template == 2 && <SectionThemeTwoEditor />}
        {settingsData?.template == 3 && <SectionThemeThreeEditor />}
        {settingsData?.template == 10 && <SectionThemeThreeEditorBlack />}
        {settingsData?.template == 4 && <SectionThemeFourEditor />}
        {settingsData?.template == 5 && <SectionThemeFiveEditor />}
      </div>
      </div>
    </>
  );
}

export default Edit;
